const component = require('../component/component');

const label = Object.assign({}, component, {
    subelements: {
        //the button label.tpl prints after the value when the label has copyToClipboard
        copyToClipboard: null,
        validationMessage: null
    },

    init: function () {
        component.init.call(this);

        if (this.hasSubelement('copyToClipboard')) {
            this.subelements.copyToClipboard.onclick = () => { this.doCopyToClipboard(); };
        }
    },

    //copies the plain value, without the tags or the secondary line the label shows (helper.copyToClipboard() says it
    //was copied). Read from the attribute as written, not from rawValue: readZAttributes() parses that one as JSON, so a
    //long all-digit code would come back as a rounded number (12345678901234567890 → 12345678901234567000)
    doCopyToClipboard: function () {
        let text = typeof this.element.dataset.zitRawValue !== typeof undefined ? this.element.dataset.zitRawValue : '';

        this.hm.helper.copyToClipboard(text);
    },

    formPostData: function (formPostData) {
        return formPostData;
    },

    setElementValue: function (value) {
        this.element.innerHTML = value;
        this.dispatchChangeEvents();
    },

    getValue: function () {
        return this.rawValue;
    }
});

module.exports = label;